import template from './user.html';
import controller from './user.controller';
import './user.scss';

const userComponent = {
  bindings: {},
  template,
  controller,
};

export default userComponent;



// WEBPACK FOOTER //
// ./client/app/components/user/user.component.js